module.exports = __webpack_public_path__ + "static/media/powerdown.0ad32954.mp3";